import "react";
import { Button, Icon } from "@therms/atalaya";
import { IoClose } from "react-icons/io5";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Select/SelectMultiOptionWrapper.tsx
var SelectMultiOptionWrapper = ({ children, onRemove }) => /* @__PURE__ */ jsxs("div", {
	className: "bg-surface rounded-default inline-flex h-full",
	children: [/* @__PURE__ */ jsx("div", {
		className: "flex max-w-[20rem] min-w-0 items-center",
		children
	}), !!onRemove && /* @__PURE__ */ jsx(Button, {
		size: "sm",
		onClick: onRemove,
		subtle: true,
		variant: "critical",
		className: "p-xxs",
		children: /* @__PURE__ */ jsx(Icon, {
			Icon: IoClose,
			size: "sm"
		})
	})]
});
//#endregion
export { SelectMultiOptionWrapper };

//# sourceMappingURL=SelectMultiOptionWrapper.js.map